import { SearchIcon } from '@heroicons/react/outline';
import { createBaseColumn } from '../../utils/columnUtils';
import { TableTemplate } from '../../types';

export const tiktokProspectingTemplate: TableTemplate = {
  id: 'tiktok_prospecting',
  name: 'TikTok Prospecting',
  description: 'Research and analyze TikTok creators for your campaigns',
  icon: SearchIcon,
  iconName: 'SearchIcon',
  variant: 'gradient',
  defaultConfig: {
    columns: [
      createBaseColumn('tiktok_followers', 'Followers', {
        cell_type: 'normal',
        prompt: 'Get this creator\'s follower count specifically from their TikTok account only. Do not use data from Instagram, YouTube, or other platforms.',
        data_type: 'number',
        platform_resources: [{ platform: 'tiktok', type: 'social_media' }]
      }),
      createBaseColumn('avg_likes', 'Average Likes', {
        cell_type: 'normal',
        prompt: 'Calculate the average number of likes (hearts) per video specifically from this creator\'s TikTok account. Analyze their recent 5 TikTok videos only, do not include likes from other platforms.',
        data_type: 'number',
        platform_resources: [{ platform: 'tiktok', type: 'social_media' }]
      }),
      createBaseColumn('engagement_rate', 'Engagement Rate', {
        cell_type: 'normal',
        prompt: 'Calculate this creator\'s engagement rate specifically for TikTok by analyzing their latest 5 TikTok videos. Step 1: Calculate the AVERAGE hearts (likes) across the 5 videos. Step 2: Calculate the AVERAGE views across the 5 videos. Step 3: Use the formula: (Average likes / Average views) * 100. Return the exact percentage number with at least 2 decimal places (e.g., "0.03" for 0.03%, "0.5" for 0.5%, "2.5" for 2.5%). Only use TikTok data, ignore other platforms.',
        data_type: 'percentage',
        platform_resources: [{ platform: 'tiktok', type: 'social_media' }]
      }),
      createBaseColumn('content_type', 'Content Type', {
        cell_type: 'normal',
        prompt: 'Analyze what type of content this creator posts specifically on TikTok. Categories might include: dance, comedy, lifestyle, beauty, food, education, music, trends, etc. Focus only on their TikTok content style.',
        data_type: 'text',
        platform_resources: [{ platform: 'tiktok', type: 'social_media' }]
      })
    ]
  }
};
